import EventRegister from './EventRegister.vue'
import Events from './Events.vue'

export default {
  EventRegister,
  Events
}



// WEBPACK FOOTER //
// ./src/components/Events/index.js